import React from "react";
import { motion } from "framer-motion";
import { PackageOpen, FileX2, Timer } from "lucide-react";

const USPS = [
  {
    no: "01",
    Icon: PackageOpen,
    title: "Any MOQ",
    body: "Order 500 pouches or 5,00,000. Start small, scale fast — no minimums that hurt your runway.",
    tag: "From 500 pcs",
  },
  {
    no: "02",
    Icon: FileX2,
    title: "Without Cylinders",
    body: "Skip the ₹40,000 cylinder bill. Our digital print line means zero tooling cost and full design freedom.",
    tag: "₹0 setup",
  },
  {
    no: "03",
    Icon: Timer,
    title: "7-Day Delivery",
    body: "From approved artwork to doorstep in a single working week. Built for D2C velocity and seasonal launches.",
    tag: "On-time, every time",
  },
];

export default function USPs() {
  return (
    <section
      id="why"
      data-testid="usps-section"
      className="relative bg-white py-20 md:py-28"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-12 gap-6 mb-14">
          <div className="col-span-12 md:col-span-5">
            <div className="text-[11px] font-bold uppercase tracking-[0.28em] text-[#1B3F8F] mb-4 flex items-center gap-3">
              <span className="inline-block w-8 h-px bg-[#F58220]" />
              Why PouchKart
            </div>
            <h2 className="font-display text-3xl md:text-5xl font-black uppercase leading-[0.95] tracking-tighter">
              Three promises<br />we don’t break.
            </h2>
          </div>
          <div className="col-span-12 md:col-span-6 md:col-start-7 flex md:items-end">
            <p className="text-base md:text-lg text-[#0a1128]/75 font-medium leading-relaxed">
              Most pouch makers ask you to commit to 50,000 units and a month of
              waiting. We re-engineered the entire flow — film, print,
              lamination, pouching — so growing brands can iterate as fast as
              they think.
            </p>
          </div>
        </div>

        <div
          className="grid grid-cols-1 md:grid-cols-3 gap-0 border border-[#d1d5db]"
          data-testid="usps-grid"
        >
          {USPS.map((u, i) => (
            <motion.div
              key={u.no}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.5, delay: i * 0.12 }}
              data-testid={`usp-card-${i}`}
              className={`group relative p-8 md:p-10 bg-white hover:bg-[#F8F9FA] transition-colors ${
                i < USPS.length - 1
                  ? "border-b md:border-b-0 md:border-r border-[#d1d5db]"
                  : ""
              }`}
            >
              <div className="flex items-start justify-between mb-8">
                <span className="font-display text-xs font-bold tracking-[0.32em] text-[#1B3F8F]">
                  / {u.no}
                </span>
                <span className="inline-block bg-[#F58220] text-white text-[10px] font-bold uppercase tracking-[0.18em] px-2.5 py-1">
                  {u.tag}
                </span>
              </div>

              <div className="w-14 h-14 mb-6 flex items-center justify-center bg-[#0a1128] text-[#F58220] group-hover:bg-[#F58220] group-hover:text-white transition-colors">
                <u.Icon size={28} strokeWidth={1.6} />
              </div>

              <h3 className="font-display text-2xl md:text-3xl font-black uppercase tracking-tight text-[#0a1128] mb-3">
                {u.title}
              </h3>
              <p className="text-[15px] leading-relaxed text-[#0a1128]/75 font-medium">
                {u.body}
              </p>

              <div className="mt-8 flex items-center gap-2 text-[#1B3F8F] text-[12px] font-bold uppercase tracking-[0.18em]">
                <span className="w-6 h-px bg-[#F58220]" />
                Standard offering
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
